import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NotificationConfigData } from './notification-config-data';
import { NotificationStatus } from './notification-status';
import { NotificationComponent } from './notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  open(
    message: string,
    status?: NotificationStatus,
    snackBarConfig?: MatSnackBarConfig
  ) {
    const config: MatSnackBarConfig<NotificationConfigData> = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      ...snackBarConfig,
      data: { message, status }
    };

    this.snackBar.openFromComponent(NotificationComponent, config);
  }
}
